import "slick-carousel";
import $ from "jquery";
//読み込み後実行
$(() => {
  //スライダー
  $(".slickWrap").each(function () {
    const dotElem = $(this).find(".slickDots");

    const sliderOptions = {
      autoplay: true,
      infinite: true,
      arrows: false,
      fade: false,
      dots: true,
      centerMode: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      centerPadding: "0",
      focusOnSelect: false,
      touchMove: true,
      appendDots: dotElem,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            autoplay: true,
            dots: true,
            draggable: true,
            touchMove: true,
          },
        },
      ],
    };

    //cloneの数が足りなくて左側に余白ができるので、追加cloneをいれた上で、追加分左にずらす
    $(this)
      .find(".slickContent")
      .on("init", function (event, slick) {
        addClone($(this));
      });

    if ($(this).find(".slickContent li").length <= 4) {
      sliderOptions["autoplay"] = false;
      sliderOptions["dots"] = false;
      sliderOptions["draggable"] = false;

      $(this).find(".slickContent").addClass("pcNoslide");
    }

    $(this).find(".slickContent").slick(sliderOptions);
  });

  //記事中のアコーディオン
  if ($(".article__accordionContent").length > 0) {
    $(".article__accordionTitle").on("click", function () {
      const parent = $(this).parents(".article__accordionContent");
      parent.toggleClass("article__accordionContent--active");
      parent.find(".article__accordionbody").slideToggle();
    });
  }

  function addClone(sliderElem) {
    console.log(sliderElem);
    const addStart = -3;
    const addCount = 2;
    const addMax = addStart - addCount;
    let addElemWidth = 0;
    setTimeout(() => {
      for (let i = addStart; i > addMax; i--) {
        const elem = sliderElem.find(".slick-slide").eq(i).clone();
        elem.attr("data-slick-index", i).addClass("slick-cloned").addClass("slick-cloned-add");
        sliderElem.find(".slick-track").prepend(elem);
        addElemWidth += sliderElem.width();
      }
      const allWidth = sliderElem.find(".slick-slide").length * sliderElem.width();
      sliderElem.find(".slick-track").css("width", `${allWidth}px`);

      if (sliderElem.find(".slick-slide").length > 1) sliderElem.find(".slick-track").css("margin-left", `-${addElemWidth}px`);
    }, 10);
  }
});
